import { render, staticRenderFns } from "./FooterCmpt.vue?vue&type=template&id=e43b2a7c&lang=pug&"
import script from "./FooterCmpt.vue?vue&type=script&lang=ts&"
export * from "./FooterCmpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFooter,VSpacer})
